import {PageError} from './PageError.js'

export class GetRemoteUrlError extends PageError {}
